export enum DACSteps {
  IBAN_GATE_STEP = 'IBAN_GATE_STEP',
  BANK_SELECTION_STEP = 'BANK_SELECTION_STEP',
  BANK_LOGIN_STEP = 'BANK_LOGIN_STEP',
  TAN_STEP = 'TAN_STEP',
  DAC_SUCCESS_STEP = 'DAC_SUCCESS_STEP',
}
